module.exports = __webpack_public_path__ + "static/img/game1.156d8d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game1.png
// module id = 1QzM
// module chunks = 1